import { CSSProperties } from 'react';
import styled, { css } from 'styled-components';

export type RadioIconState = 'default' | 'checked';

const Container = styled.div<{ $state: RadioIconState }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  border: 1px solid ${({ theme }) => theme.colors.neutral.neutral_alpha[7]};
  background-color: transparent;
  border-radius: 50%;

  height: ${({ theme }) => theme.typography.font.size[4]}px;
  width: ${({ theme }) => theme.typography.font.size[4]}px;

  ${({ theme, $state }) => {
    if ($state === 'checked')
      return css`
        background-color: ${theme.colors.accent.accent[9]};
        border-color: ${theme.colors.accent.accent['8']};
      `;
  }};
`;

const CheckIndicator = styled.div`
  display: flex;
  background-color: ${({ theme }) => theme.tokens.colors.accent_contrast};

  border-radius: 50%;
  height: ${({ theme }) => theme.spacing[2]}px;
  width: ${({ theme }) => theme.spacing[2]}px;
`;

interface RadioIconProps {
  $state: RadioIconState;
  style?: CSSProperties;
}

export default function RadioIcon(props: RadioIconProps) {
  const { $state, style } = props;
  return (
    <Container $state={$state} style={style}>
      {$state === 'checked' ? <CheckIndicator /> : null}
    </Container>
  );
}
